import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SafeHtml } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { ManualContentService } from '../manual-content.service';
import { ManualPage } from '@app/shared/models/enums/manualPage.enum';

interface AdditionalInstructionsData {
  manualKey: ManualPage;
}

interface ManualViewState {
  loading: boolean;
  content: SafeHtml | null;
}

@Component({
  selector: 'flow-additional-instructions-modal',
  templateUrl: './additional-instructions-modal.component.html',
  styleUrls: ['./additional-instructions-modal.component.scss'],
})
export class AdditionalInstructionsModalComponent implements OnInit {
  state$: Observable<ManualViewState>;

  constructor(
    private manualContent: ManualContentService,
    @Inject(MAT_DIALOG_DATA) private data: AdditionalInstructionsData
  ) {}

  ngOnInit(): void {
    this.state$ = this.manualContent.getManual(this.data.manualKey).pipe(
      map(content => ({ loading: false, content })),
      startWith({ loading: true, content: null as SafeHtml | null })
    );
  }

  onContentClick(event: MouseEvent): void {
    const anchor = (event.target as HTMLElement)?.closest('a');
    const href = anchor?.getAttribute('href');
    if (!href || !href.startsWith('#')) {
      return;
    }
    event.preventDefault();
    const id = decodeURIComponent(href.slice(1));
    const container = event.currentTarget as HTMLElement;
    const target = container.querySelector(`[id="${CSS.escape(id)}"]`);
    target?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}
